import { type FC } from 'react'
import { JsonLd } from 'react-schemaorg'

import { useCdnMediaServer } from '../../../cdn'
import { useGlobalConfigContext } from '../../../global-config'
import { IMAGE_PRODUCT_FALLBACK_SRC } from '../../../image'
import { TENANTS_WITH_MARKETPLACE_FUNCTIONALITY } from '../../../marketplace'
import { productAccessorStockStatusIsAvailable } from '../../model/productAccessor/productAccessorStockStatusIsAvailable'
import { productPageGetJsonLdProductPageDescriptionSchema } from '../../seo/schemas/getProductDescriptionSchema'
import { useProductPageContext } from '../productPageContext'

export const ProductPageJsonLdProductDescription: FC = () => {
  const { tenant } = useGlobalConfigContext()
  const { product, reviewData } = useProductPageContext()

  const { setMediaServerOrigin } = useCdnMediaServer()

  if (!productAccessorStockStatusIsAvailable(product)) {
    return null
  }

  const isMarketplace = TENANTS_WITH_MARKETPLACE_FUNCTIONALITY.has(tenant)
  const fallback = setMediaServerOrigin(IMAGE_PRODUCT_FALLBACK_SRC)

  return (
    <JsonLd
      item={productPageGetJsonLdProductPageDescriptionSchema({
        fallback,
        isMarketplace,
        product,
        reviews: reviewData.productReviews.reviews,
      })}
    />
  )
}
